import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const DoolittleProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid doolittle-project container">
                <div className="flex">
                    <div className="grid-col-1">
                        {/*<img className="grid-img-1" src="/assets/img/homes/doolittle/02.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                        <svg className="grid-svg-1" x="0px" y="0px" width="420" height="10" viewBox="0 0 420 10">
                            <text className="doolittle-text barlow-it" x="0" y="10" fill="#8a8a8a" textLength="418">
                                DoOoOoOoOoOooOo
                            </text>
                        </svg>
                    </div>
                    {/*<img className="grid-img-2" src="/assets/img/homes/doolittle/03.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-2', asset: gridImages[2], sizes: ''}}/>
                </div>
                <div className="flex flex-container-1">
                    {/*<img className="grid-img-3" src="/assets/img/homes/doolittle/04.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-3', asset: gridImages[3], sizes: ''}}/>
                    <svg style={{display: 'block'}} x="0px" y="0px" width="124" height="250" viewBox="0 0 124 250">
                        <text className="doolittle-text2 barlow-re" x="0" y="10" fill="#af2100" textLength="681">
                            <tspan x="0" style={{letterSpacing: '19.6px'}}>LITTLE</tspan>
                            <tspan x="0" dy="60" style={{letterSpacing: '14px'}}>LITTLE</tspan>
                            <tspan x="0" dy="60" style={{letterSpacing: '3.6px'}}>LITTLE</tspan>
                            <tspan x="0" dy="60" style={{letterSpacing: '14px'}}>LITTLE</tspan>
                            <tspan x="0" dy="60" style={{letterSpacing: '19.6px'}}>LITTLE</tspan>
                        </text>
                    </svg>
                </div>
                <div className="flex">
                    <div className="grid-col-2">
                        <svg className="grid-svg-2" x="0px" y="0px" width="579" height="190" viewBox="0 0 579 190">
                            <text className="doolittle-text3" x="0" y="10" fill="#000" textLength="2493">
                                <tspan className="yrsa-li" x="0">doolittle</tspan>
                                <tspan className="barlow-it" x="0" dy="60">doolittle</tspan>
                                <tspan className="barlow-bo" x="0" dy="60">doolittle</tspan>
                                <tspan className="yrsa-li" x="0" dy="60">doolittle</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-4" src="/assets/img/homes/doolittle/06.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-4', asset: gridImages[5], sizes: ''}}/>
                    </div>
                    <div className="grid-col-3">
                        {/*<img className="grid-img-5" src="/assets/img/homes/doolittle/05.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-5', asset: gridImages[4], sizes: ''}}/>
                        <svg className="grid-svg-3" x="0px" y="0px" width="72" height="170" viewBox="0 0 72 170">
                            <text className="doolittle-text4 yrsa-li" x="0" y="10" fill="#000">
                                <tspan x="0">D O O &nbsp;.</tspan>
                                <tspan x="0" dy="20">D O O &nbsp;.</tspan>
                                <tspan x="0" dy="20">D O O &nbsp;.</tspan>
                                <tspan x="0" dy="20">D O O &nbsp;.</tspan>
                                <tspan x="0" dy="20">D O O &nbsp;.</tspan>
                                <tspan x="0" dx="33">L I T T L E .</tspan>
                                <tspan x="0" dx="33" dy="20">L I T T L E .</tspan>
                                <tspan x="0" dx="33" dy="20">L I T T L E .</tspan>
                                <tspan x="0" dx="33" dy="20">L I T T L E .</tspan>
                                <tspan x="0" dx="33" dy="20">L I T T L E .</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
                {/*<img className="grid-img-6" src="/assets/img/homes/doolittle/07.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-6', asset: gridImages[6], sizes: ''}}/>
                <div className="flex flex-container-2">
                    <div className="flex grid-col-4">
                        <svg className="grid-svg-4" x="0px" y="0px" width="62" height="308" viewBox="0 0 62 308">
                            <text className="doolittle-text5 barlow-re" x="0" y="7" fill="#8a8a8a" textLength="470">
                                <tspan x="0">Doo</tspan>
                                <tspan x="0" dy="60">Doo</tspan>
                                <tspan x="0" dy="60">Doo</tspan>
                                <tspan x="0" dy="60">Doo</tspan>
                                <tspan x="0" dy="60">Doo</tspan>
                                <tspan x="0" dy="60">Doo</tspan>
                            </text>
                        </svg>
                        <svg className="grid-svg-5" x="0px" y="0px" width="145" height="308" viewBox="0 0 145 308">
                            <text className="doolittle-text6 barlow-it" x="0" y="7" fill="#8a8a8a" textLength="979">
                                <tspan x="0">Little</tspan>
                                <tspan x="0" dy="60">Little</tspan>
                                <tspan x="0" dy="60">Little</tspan>
                                <tspan x="0" dy="60">Little</tspan>
                                <tspan x="0" dy="60">Little</tspan>
                                <tspan x="0" dy="60">Little</tspan>
                            </text>
                        </svg>
                    </div>
                    {/*<img className="grid-img-7" src="/assets/img/homes/doolittle/08.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-7', asset: gridImages[7], sizes: ''}}/>
                </div>
                <div className="flex flex-container-3">
                    <div className="grid-col-5">
                        {/*<img className="grid-img-8" src="/assets/img/homes/doolittle/09.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-8', asset: gridImages[8], sizes: ''}}/>
                        {/*<img className="grid-img-9" src="/assets/img/homes/doolittle/11.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-9', asset: gridImages[10], sizes: ''}}/>
                        <svg className="grid-svg-6" x="0px" y="0px" width="64" height="10" viewBox="0 0 64 10">
                            <text className="doolittle-text7 barlow-bo" x="0" y="7" fill="#000" textLength="61">
                                LIT
                            </text>
                        </svg>
                    </div>
                    {/*<img className="grid-img-10" src="/assets/img/homes/doolittle/10.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-10', asset: gridImages[9], sizes: ''}}/>
                </div>
                <div className="flex">
                    {/*<img className="grid-img-11" src="/assets/img/homes/doolittle/12.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-11', asset: gridImages[11], sizes: ''}}/>
                    <svg className="grid-svg-7" x="0px" y="0px" width="66" height="10" viewBox="0 0 66 10">
                        <text className="doolittle-text7 barlow-bo" x="0" y="7" fill="#000" textLength="61">
                            TLE
                        </text>
                    </svg>
                </div>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Magazine</span> Doolittle</li>
                            <li><span className="red barlow-me">Photographer</span> Coco Amardeil</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default DoolittleProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(DoolittleProjectGrid));


// WEBPACK FOOTER //
// ./src/components/DoolitleProjectGrid.js